import classNames from 'classnames';
const CALLIE_PROMPT_VARIABLE_PATTERN = /<CalliePromptVariable label="([^"]+)">([\s\S]*?)<\/CalliePromptVariable>/g;
const variableCss = "v14bojw9";
const variableWithLabelCss = "v3u87zo";
const variableValueCss = "v1oaysr1";
const variableLabelCss = "vg16ho9";
const CalliePromptVariable = ({
  children,
  label
}) => <span className={classNames(variableCss, label && variableWithLabelCss)}>
    <span className={variableValueCss}>{children}</span>
    {label && <span className={variableLabelCss}>
        {label}
      </span>}
  </span>;
export const parseCalliePromptHtml = htmlString => {
  const parts = [];
  let lastIndex = 0;
  for (const match of htmlString.matchAll(CALLIE_PROMPT_VARIABLE_PATTERN)) {
    if (match.index > lastIndex) {
      parts.push(htmlString.slice(lastIndex, match.index));
    }
    const [, label, children] = match;
    parts.push(<CalliePromptVariable key={`${match.index}-${label}`} label={label}>
        {children}
      </CalliePromptVariable>);
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < htmlString.length) {
    parts.push(htmlString.slice(lastIndex));
  }
  return parts;
};

require("./prompt_variable.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./prompt_variable.js");